import { ContentLayout, Header } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../../layout/Layout";

const StylesheetDoc: FC<any> = () => {
    return (
        <Layout>
            <ContentLayout header={<Header variant="h1">Documentation</Header>}>
                <>Stylesheet Documentation</>
            </ContentLayout>
        </Layout>
    )
}
export default StylesheetDoc;